import api from './api';

/**
 * Valida el CBU contra el CUIT del cliente mediante lenders_backoffice.
 */
export const validateCustomerCbu = async (customerKey, cbu) =>
  api.post(`/customers/${customerKey}/cbu/validate`, { cbu });
